import { TOGGLE_MENU } from './constants'

export const ToggleMenu = () => (dispatch) => {
  dispatch({
    type: TOGGLE_MENU,
    payload: undefined,
  })
}
